export default {"src":"/_next/static/media/MummyRawr.5ca2c1d5.svg","height":206,"width":145};